import { Colors, Language, Lightning, Router, Log } from '@lightningjs/sdk'
import CatchupPageWrapper from '../components/CatchupPageWrapper'
import Loader from '../components/Loader2'
import TopMenu from '../components/TopMenu'
import { getCatchUp } from '../lib/api/Api'
import { isInteger } from '../lib/AppHelpers'
import { appSettings } from '../lib/AppSettings'

export default class CatchUp extends Lightning.Component {
  static _template() {
    return {
      TopMenu: { type: TopMenu },
      BG: { w: 1920, h: 1080, rect: true, color: Colors('PageBG').get() },
      Loader: { x: 1665, y: 275, type: Loader, zIndex: 200 },
      PageWrapper1: {
        type: CatchupPageWrapper,
        isActiveWrapper: false,
        signals: { wrapperBuild: true },
      },
      PageWrapper2: {
        type: CatchupPageWrapper,
        isActiveWrapper: false,
        signals: { wrapperBuild: true },
      },
    }
  }

  pageTransition() {
    return 'fade'
  }
  playbackError() {
    this.widgets.errorbox.alpha = 1
    this.widgets.errorbox.notify({
      type: 'playbackStopped',
      Notification: true,
    })
    Router.focusWidget('ErrorBox')
  }

  set data({ index = 0, brand, items }) {
    this._items = items
    this._brand = brand
    this._brandIndex = index
    this._brandName = brand.brandName

    this.tag('TopMenu').brand = { index, brandName: brand.brandName }
    this._setState('TopMenu')
  }

  _init() {
    this._brandIndex = 0
    this._currentWrapper = 'PageWrapper2'
    this.widgets['sidemenu'].activeMenuItem = 1
    this._setState('TopMenu')
    this.tag('PageWrapper1')
      .transition('x')
      .on('finish', () => {
        this.tag('Loader').stop()
        if (this._gridMainIndex > -1 && this._gridCrossIndex > -1) {
          this.tag('PageWrapper1').gridMainIndex = this._gridMainIndex
          this.tag('PageWrapper1').gridCrossIndex = this._gridCrossIndex
          this._gridMainIndex = -1
          this._gridCrossIndex = -1
        }
        if (this._lastFocusedState) {
          this._setState(this._lastFocusedState)
          this._lastFocusedState = null
        } else {
          this._setState('TopMenu')
        }
      })
  }
  historyState(params) {
    if (params && params.gridMainIndex > -1 && params.gridCrossIndex > -1) {
      this._historyBrandName = params.radioBrand
      this._gridMainIndex = params.gridMainIndex
      this._gridCrossIndex = params.gridCrossIndex
      this._lastFocusedState = params.state
    } else {
      return {
        brandIndex: this._brandIndex,
        radioBrand: appSettings.brands[this._brandIndex].brandName,
        gridMainIndex: this.tag(this._currentWrapper).gridMainIndex,
        gridCrossIndex: this.tag(this._currentWrapper).gridCrossIndex,
        index: this.tag(this._currentWrapper).gridIndex,
        state: this._getState(),
      }
    }
  }

  _firstActive() {
    this._appStart = true
  }

  _buildPage() {
    appSettings.currentBrand = appSettings.brands[this._brandIndex]
    const data = {
      bg: appSettings.currentBrand.background,
      pageTitle: `${appSettings.currentBrand.name} ${Language.translate('CatchupTitle')}`,
      brandName: appSettings.currentBrand.brandName,
      items: this._items,
      menu: {
        index: this._brandIndex,
        brand: appSettings.currentBrand.brandName,
      },
    }

    const newWrapper = this._getNewWrapper()

    data.wrapper = newWrapper

    this.tag(newWrapper.name).pageData = data
    this.tag(newWrapper.name).isActiveWrapper = true

    this.tag(this._currentWrapper).isActiveWrapper = false

    this._currentWrapper = newWrapper.name
  }

  wrapperBuild({ wrapper }) {
    const buildWrapper = wrapper

    this._currentWrapper = buildWrapper

    const inX = 0
    const outX = this._dir === 'right' ? -1920 : 1920
    const startX = -outX
    const inWrapper = buildWrapper
    const outWrapper = buildWrapper === 'PageWrapper1' ? 'PageWrapper2' : 'PageWrapper1'

    this.tag(inWrapper).x = startX

    this.tag(inWrapper).patch({
      smooth: {
        x: [
          inX,
          {
            duration: 0.4,
            delay: 0.2,
            timingFunction: 'cubic-bezier(.5,0,.5,1)',
          },
        ],
      },
    })

    this.tag(outWrapper).patch({
      smooth: {
        x: [
          outX,
          {
            duration: 0.4,
            delay: 0.2,
            timingFunction: 'cubic-bezier(.5,0,.5,1)',
          },
        ],
      },
    })

    this.tag(outWrapper).clear()

    this.stage.gc()

    this._currentWrapper = buildWrapper
  }

  _getNewWrapper() {
    if (this._currentWrapper === 'PageWrapper1') {
      return { name: 'PageWrapper2', nr: 2 }
    } else {
      return { name: 'PageWrapper1', nr: 1 }
    }
  }
  _handleBack() {
    Log.info('Console:HandleBack')
    Router.focusWidget('SideMenu')
  }

  changeStation(radioIndex, dir) {
    this._brandIndex = radioIndex
    this._dir = dir

    appSettings.currentBrand = appSettings.brands[radioIndex]

    this._stationSelectTimeStamp = Date.now()
    getCatchUp(appSettings.currentBrand, this._stationSelectTimeStamp).then(response => {
      this._items = response.data.items
      this._brand = appSettings.currentBrand

      if (this._stationSelectTimeStamp === response.timestamp || response.timestamp === undefined) {
        this._buildPage(dir)
      }
    })
  }

  _inactive() {
    this.stage.gc()
  }

  static _states() {
    return [
      class Idle extends this {},

      class Wrapper extends this {
        $enter() {
          this.tag('TopMenu').navigating = false
          this.tag('TopMenu')._unfocus()
        }
        _handleUp() {
          this._setState('TopMenu')
        }

        _handleLeft() {
          Router.focusWidget('SideMenu')
        }

        _getFocused() {
          return this.tag(this._currentWrapper)
        }
      },

      class TopMenu extends this {
        $enter() {
          this.tag('TopMenu').navigating = false
        }

        _handleDown() {
          this._setState('Wrapper')
        }

        $menuIndexChanged({ dir, index }) {
          this.mnuIdx = this.tag('TopMenu').activeMenuItem.dataIndex
          if (isInteger(index)) {
            this.tag('Loader').start()

            setTimeout(() => {
              this._activeIndex = index //this.mnuIdx;

              this.tag('TopMenu').navigating = true

              this._setState('Idle')

              this.changeStation(this.mnuIdx, dir)
            }, 200)
          }
        }

        _getFocused() {
          return this.tag('TopMenu')
        }
      },
    ]
  }
}
